import { NotificationManager } from 'react-notifications';
import {
  createAPIAccessKeyRequest,
  createIssuerAPIAccessKeyRequest,
  deleteAccessKeyStatusRequest,
  getAPIAccessKeyRequest,
  getIssuerAPIAccessKeyRequest,
  toggleAccessKeyStatusRequest,
  toggleIssuerAccessKeyStatusRequest,
  updateAPIAccessKeyRequest,
  updateIssuerAPIAccessKeyRequest
} from 'src/api/AccessKeyRequest';
import { requestWrapper } from 'src/utils/utils';
import { checkRequestError } from '.';
import { GET_API_ACCESS_KEY } from '../types';

export const getAPIAccessKeyAction = (filterObj, profile) => async (
  dispatch
) => {
  try {
    const { data } =
      profile?.super == 1
        ? await getAPIAccessKeyRequest(filterObj)
        : await getIssuerAPIAccessKeyRequest(filterObj);
    checkRequestError(data);

    dispatch({
      type: GET_API_ACCESS_KEY,
      payload: data.content.data?.all || []
    });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    // NotificationManager.info(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const createAPIAccessKeyAction = (payload, profile) => async (
  dispatch
) => {
  try {
    const { data } =
      profile?.super == 1
        ? await createAPIAccessKeyRequest(requestWrapper(payload))
        : await createIssuerAPIAccessKeyRequest(requestWrapper(payload));
    checkRequestError(data);

    dispatch(getAPIAccessKeyAction({}, profile));
    NotificationManager.success(data.success.message, 'Success');
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const updateAPIAccessKeyAction = (id, payload, profile) => async (
  dispatch
) => {
  try {
    const { data } =
      profile?.super == 1
        ? await updateAPIAccessKeyRequest(id, requestWrapper(payload))
        : await updateIssuerAPIAccessKeyRequest(id, requestWrapper(payload));
    checkRequestError(data);

    dispatch(getAPIAccessKeyAction({}, profile));
    NotificationManager.success(data.success.message, 'Success');
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const toggleAPIAccessKeyAction = (id, payload, profile) => async (
  dispatch
) => {
  try {
    const { data } =
      profile?.super == 1
        ? await toggleAccessKeyStatusRequest(id, requestWrapper(payload))
        : await toggleIssuerAccessKeyStatusRequest(id, requestWrapper(payload));
    checkRequestError(data);

    dispatch(getAPIAccessKeyAction({}, profile));
    NotificationManager.success(data.success.message, 'Success');
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const deleteAPIAccessKeyAction = (id, profile) => async (dispatch) => {
  try {
    const { data } = await deleteAccessKeyStatusRequest(id);
    checkRequestError(data);

    dispatch(getAPIAccessKeyAction({}, profile));
    NotificationManager.success(data.success.message, 'Success');
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};
